// @ts-check
import React, { Suspense, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { useParams } from 'react-router-dom'
import MdcAppLoader from './MdcAppLoader'

const ProfileSettings = React.lazy(
  () =>
    import('./settings/ProfileSettings/ProfileSettings' /* webpackChunkName: "ProfileSettings" */)
)
const LoginModal = React.lazy(() => import('./LoginModal' /* webpackChunkName: "LoginModal" */))

/** @typedef {{ userSettings?: { authenticated?: boolean }, containerId?: string }} Props */

/**
 * @param {Props} props
 */
function ProfileSettingsLoader({ userSettings, containerId = 'personsettings-root' }) {
  const { personPostSlug } = useParams()
  useEffect(() => {
    /** @type {import('react-dom/client').Root | undefined} */
    let root
    const container = document.getElementById(containerId)
    if (container) {
      root = createRoot(container)
      if (userSettings?.authenticated && personPostSlug) {
        root.render(
          <Suspense fallback={<MdcAppLoader />}>
            <ProfileSettings personPostSlug={personPostSlug} />
          </Suspense>
        )
      } else {
        root.render(
          <Suspense fallback={<MdcAppLoader />}>
            <LoginModal />
          </Suspense>
        )
      }
    }
    return () => {
      setTimeout(() => root?.unmount())
    }
  }, [userSettings?.authenticated, personPostSlug, containerId])
  return <></>
}

export default ProfileSettingsLoader
